<template>
  <div v-if="loading" class="space-y-2">
    <div v-for="_ in 3" :key="_" class="h-[208px] rounded-2xl skeleton-loading"/>
  </div>

  <div v-else>
    <div
      v-if="paymentMethods.length"
      class="space-y-2">
      <div
        v-for="item in paymentMethods"
        :key="item.id"
        :class="[activePaymentMethod.id === item.id ? 'border-2 border-primary' : 'border-2 border-gray-100']"
        class="flex flex-col justify-between rounded-2xl px-4 pt-6 pb-1 h-52">
        <div class="border-b border-gray-200 flex items-center justify-between whitespace-nowrap">
          <span>{{ $t('user.your_cards.card_number') }}:</span>

          <span class="ml-2 font-mono text-caption text-gray-500">
            **** **** **** {{ item.card.last4 }}
          </span>
        </div>

        <InlineSvg
          :src="require(`@/assets/svg/cards/${item.card.brand.toLowerCase()}.svg`)"
          class="w-20 h-auto"/>

        <div class="flex justify-between -mx-1.5">
          <button
            type="button"
            class="btn text-primary-press px-1.5 py-1 mt-1 text-caption"
            @click="$refs.removeCard.openModal({ paymentMethodId: item.id })">
            {{ $t('user.your_cards.remove_card') }}
          </button>

          <span
            v-if="purchaseConfig.currentPaymentMethodId === item.id"
            class="text-caption text-gray-600 px-1.5 flex items-center justify-center">
            {{ $t('user.your_cards.primary') }}
          </span>

          <button
            v-else
            type="button"
            class="btn text-link px-1.5 py-1 mt-1 text-caption"
            @click="setPrimaryPaymentMethod(item)">
            {{ $t('user.your_cards.set_primary') }}
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <p class="my-2">
        {{ $t('user.your_cards.no_saved_cards') }}

        <template v-if="['stripe'].includes(paymentProcessor)">
          <a
            class="cursor-pointer text-link"
            @click="addCard">{{ $t('user.your_cards.add_card') }}</a>.
        </template>
      </p>
    </div>

    <Modal
      v-slot="{ closeModal, values }"
      ref="removeCard"
      name="RemoveCard">
      <RemoveCardContent
        :values="values"
        @close="closeModal()"/>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Functional/Modal'
import RemoveCardContent from '@/components/ModalContents/RemoveCardContent'
import { mapActions, mapState, mapWritableState } from 'pinia'
import { usePaymentStore } from '@/stores/payment'

export default {
  name: 'CardsList',
  components: {
    Modal,
    RemoveCardContent
  },
  data () {
    return {
      loading: true,
      errorMessage: ''
    }
  },
  computed: {
    ...mapState(usePaymentStore, [
      'paymentProcessor',
      'activePaymentMethod',
      'paymentMethods'
    ]),
    ...mapWritableState(usePaymentStore, [
      'purchaseConfig'
    ])
  },
  async mounted () {
    await this.paymentMethodsGet()
      .finally(async () => {
        await new Promise((resolve) => setTimeout(resolve, 300))
        this.loading = false
      })
  },
  methods: {
    ...mapActions(usePaymentStore, [
      'paymentMethodsGet',
      'currentPaymentMethodUpdate',
      'checkoutSessionCreate'
    ]),
    async addCard () {
      await this.checkoutSessionCreate({
        successUrl: `${window.origin}/checkout/result?is=success&type=add-card`,
        cancelUrl: `${window.origin}/checkout/result?is=cancel&type=add-card`,
        savePaymentMethod: true
      })
    },
    setPrimaryPaymentMethod (item) {
      try {
        this.currentPaymentMethodUpdate({ paymentMethodId: item.id, paymentProcessorId: this.paymentProcessor })
      } catch (error) {
        console.log('Error setting primary payment method:', error)
        this.errorMessage = error.message ? error.message : 'Uknown error occurred while setting primary payment method.'
      }
    }
  }
}
</script>

